import React from 'react'
import { useSelector } from 'react-redux'
import Map from 'components/Map'
import MapHeader from 'components/MapHeader'
import MapLegends from 'components/MapLegends'

import { selectMapBaseUrl, selectMapZoomDelta, selectPlatform } from 'store/global'

import {
  selectAllEmployeesLocations,
  selectAllBusinessesLocations,
  selectAllMarketingLocations,
  selectAllReviewsLocations,
  selectAllPermitsLocations,
} from 'store/businesses'
import styles from './BusinessesMap.scss'

interface BusinessesMapProps {
  expanded?: boolean
  onToggleExpand: () => void
  onClose: () => void
}

export default function BusinessesMap(props: BusinessesMapProps) {
  const mapBaseUrl = useSelector(selectMapBaseUrl)
  const mapZoomDelta = useSelector(selectMapZoomDelta)
  const platform = useSelector(selectPlatform)

  const employeesLocations = useSelector(selectAllEmployeesLocations)
  const businessLocations = useSelector(selectAllBusinessesLocations)
  const marketingLocations = useSelector(selectAllMarketingLocations)
  const reviewsLocations = useSelector(selectAllReviewsLocations)
  const permitsLocations = useSelector(selectAllPermitsLocations)

  return (
    <>
      <MapHeader type='businesses' {...props} />
      <div className={styles.legendContainer}>
        <MapLegends />
      </div>
      <div className={styles.container}>
        <Map
          platform={platform}
          baseUrl={mapBaseUrl}
          zoomDelta={mapZoomDelta}
          locations={[
            {
              list: employeesLocations,
              listColor: styles.employeeLocations,
            },
            {
              list: businessLocations,
              listColor: styles.physicalLocations,
            },
            {
              list: marketingLocations,
              listColor: styles.marketingLocations,
            },
            {
              list: reviewsLocations,
              listColor: styles.reviewLocations,
            },
            {
              list: permitsLocations,
              listColor: styles.permitLocations,
            },
          ]}
        />
      </div>
    </>
  )
}
